import { Component } from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";
import { GlobalKeyPress, IconButton, Portal } from "@evertrue/et-components";
import classNames from "classnames";
import WithSession from "base/session/with-session";
import EverTrue from "app";

const TIMEOUT = 200;

class RightPanel extends Component {
  static propTypes = {
    selectedTab: PropTypes.string,
    children: PropTypes.node,
    tabList: PropTypes.array,
    tabChanged: PropTypes.func,
  };
  static defaultProps = {
    selectedTab: "BY DUE DATE",
    tabList: [],
    tabChanged: id => {},
  };
  state = {
    panel_open: false,
  };

  panelButtonClicked = () => {
    this.setState(state => {
      if (!state.panel_open) {
        EverTrue.track.set("todo_action", { type: "todo_open" });
      }
      return { panel_open: !state.panel_open };
    });
  };

  handleClose = () => {
    this.setState({
      panel_open: false,
    });
  };

  render() {
    return (
      <div>
        <div className={`panel-button ${this.state.panel_open ? "panel-is-open" : ""}`}>
          <IconButton
            title="todos"
            onClick={this.panelButtonClicked}
            className="panel-button--innerbutton"
            icon="todolist"
          />
        </div>
        <Portal>
          <Transition in={this.state.panel_open} timeout={TIMEOUT} appear={true} unmountOnExit mountOnEnter>
            {transitionState => (
              <div className={classNames("panel-body", transitionState)}>
                {/* Transition mounts and unmounts so put Keypress here so event listener gets removed when not mounted */}
                <GlobalKeyPress onEscape={this.handleClose} />
                <div className="panel-body--top">
                  To-Dos
                  <IconButton icon="close" className="panel-body--close-icon" onClick={this.handleClose} />
                </div>
                <div className="panel-body--content">
                  <div className="panel-body--title">
                    <ul className="todo--tab-bar">
                      {this.props.tabList.map(option => (
                        <li
                          id={option}
                          key={option}
                          className={
                            "todo--tab-bar-item " + (this.props.selectedTab === option ? "todo--selected-tab" : "")
                          }
                          onClick={() => this.props.tabChanged(option)}
                        >
                          {option}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="panel-body--table">{this.props.children}</div>
                </div>
              </div>
            )}
          </Transition>

          {this.state.panel_open && <div className="panel-body--overlay" onClick={this.handleClose} />}
        </Portal>
      </div>
    );
  }
}

export default WithSession(RightPanel);
